import React from 'react';
import { connect } from 'react-redux';
import japanese from 'japanese';
import set from 'lodash/set';
import axios from 'axios';
import { FormSection, FieldArray, arrayPush, touch as formTouch, change as formChange } from 'redux-form';
import _, { debounce } from 'lodash';

import { EMPLOYEE_FORM } from 'src/constants/FormNames';
import { SEARCH_POSTAL_CODE_URL } from 'src/constants/EndpointUrls';
import { calAnnualEarnings, determineMaxDependentMoney } from 'jbc-front/utils/calculation';

import {
  SelectField,
  TextField,
  RadioField,
  TextFieldWithKana,
  CheckboxField,
  DateField,
  BoxDouble,
  BoxTriple,
  Section
} from 'jbc-front/components/Form';
import { PlusSquare, DeleteSquare } from 'jbc-front/components/icons';
import { isNumber, zenkakuKatakana } from 'src/utils/CustomValidators';
import selector, { fetchValueByIndexAndField } from 'src/utils/Utils';
import { handlePostalCodeChange } from 'src/utils/Form';
import { getEmployeeFormValues } from 'src/reducers/employees/employees';
import { getSelectOptions, getRadioOptions } from 'src/reducers/selectOptions';
import { PostalCodeFieldThai, TelFieldTh, PostalDropDownMenu } from 'src/components';
import { useTranslation, withTranslation } from 'react-i18next';
import i18next from 'i18next';

let GeneralInfo = props => {
  const {
    relationshipTypes,
    relationDetailTypes,
    genders,
    residentTypes,
    disabledPersonTypes,
    children,
    selectedRelationship,
    handleFirstNameKanaChange,
    handleLastNameKanaChange,
    onChangeYearlyIncome
  } = props;
  const { t } = useTranslation();
  return (
    <div>
      <RadioField label={t('features.Employees.components.FamilySupportsSection.Family')} name="relationshipType" required options={relationshipTypes} />

      {selectedRelationship &&
        selectedRelationship === 'other' && (
          <SelectField
            label={t('features.Employees.components.FamilySupportsSection.Family_details')}
            name="relationshipDetail"
            required
            options={relationDetailTypes}
            note={t('features.Employees.components.FamilySupportsSection.Can_add_a_family_member_not_in_the_list_by_direct_input')}
            creatable
          />
        )}

      <BoxDouble>
        <TextField required label={t('features.EmployeePays.components.DownloadColumnDetail.first_name')} name="firstName" onUpdateKana={handleFirstNameKanaChange} />
        <TextField required label={t('features.EmployeePays.components.DownloadColumnDetail.last_name')} name="lastName" onUpdateKana={handleLastNameKanaChange} />
      </BoxDouble>

      {/* <BoxDouble>
        <TextField label={t('features.Employees.components.BasicInfoSection.last_name')} name="lastNameKana" validate={zenkakuKatakana} />
        <TextField label={t('features.Employees.components.BasicInfoSection.first_name')} name="firstNameKana" validate={zenkakuKatakana} />
      </BoxDouble> */}

      <DateField viewMode="years" label={t('features.Employees.components.BasicInfoSection.Birth_date')} name="birthday" required />

      <RadioField label={t('features.Employees.components.BasicInfoSection.gender')} name="gender" options={genders} />

      <RadioField label={t('features.Employees.components.FamilySupportsSection.Cohabit_Separate')} name="residentType" options={residentTypes} />

      {children}

      <TextField
        label={t('features.Employees.components.FamilySupportsSectionShow.annual_revenue_Jan_Dec')}
        maxLength="9"
        name="yearlyIncome"
        validate={isNumber}
        onChange={onChangeYearlyIncome}
      />
      <TextField label={t('features.Employees.components.FamilySupportsSectionShow.annual_taxable_income_Jan_Dec')} maxLength="9" name="yearlyEarning" required validate={isNumber} />

      <RadioField label={t('features.Employees.components.FamilySupportsSectionShow.handicapped_division')} name="disabledPersonType" options={disabledPersonTypes} />

      <CheckboxField name="isTaxDependency" label={t('features.Employees.components.FamilySupportsSectionShow.tax_dependent')} />
    </div>
  );
};

GeneralInfo = connect(
  state => ({
    relationshipTypes: getRadioOptions(state, 'relationshipTypes'),
    relationDetailTypes: getRadioOptions(state, 'relationDetailTypes'),
    genders: getRadioOptions(state, 'genders'),
    residentTypes: getRadioOptions(state, 'residentTypes'),
    disabledPersonTypes: getRadioOptions(state, 'disabledPersonTypes')
  }),
  (dispatch, ownProps) => ({
    handleFirstNameKanaChange: value => {
      const prefix = ownProps.formKey;
      const firstNameKana = japanese.katakanize(value);
      dispatch(formChange(EMPLOYEE_FORM, `${prefix}.firstNameKana`, firstNameKana));
    },
    handleLastNameKanaChange: value => {
      const prefix = ownProps.formKey;
      const lastNameKana = japanese.katakanize(value);
      dispatch(formChange(EMPLOYEE_FORM, `${prefix}.lastNameKana`, lastNameKana));
    },
    onChangeYearlyIncome: (e, value) => {
      const prefix = ownProps.formKey;
      const yearlyEarning = calAnnualEarnings(value);
      dispatch(formChange(EMPLOYEE_FORM, `${prefix}.yearlyEarning`, `${yearlyEarning}`));
    }
  })
)(GeneralInfo);

let SeparatedDomesticAddr = ({ handlePostalQueryChange, postalData, postalCodeServerError, removePostalCode, selectPostal, formKey }) => {
  const { t, i18n }= useTranslation();
  return (
    <div>
      <BoxDouble>
            <TextField label={t('features.Employees.components.BasicInfoSection.address_number')} name="addressNumber" type="text" />
            <TextField label={t('features.Employees.components.BasicInfoSection.building_name')} name="building" type="text" />
          </BoxDouble>

          <BoxDouble>
            <TextField label={t('features.Clients.components.BasicInfoSectionShow.soi')} name="soi" placeholder={t('features.Clients.components.BasicInfoSectionShow.soi')}/>
            <TextField label={t('features.Clients.components.BasicInfoSectionShow.road')} name="street" placeholder={t('features.Clients.components.BasicInfoSectionShow.road')}/>
          </BoxDouble>
          
          <BoxTriple>
            <TextField disabled label={t('features.Clients.components.BasicInfoSectionShow.sub_district')} name={`employeeFamilySupportAddressInformation.subdistrict`+`${i18n.language === 'th'? "NameThai" : "NameEng"}` }/>
            <TextField disabled label={t('features.Clients.components.BasicInfoSectionShow.district')} name={`employeeFamilySupportAddressInformation.district`+`${i18n.language === 'th'? "NameThai" : "NameEng"}`} />
            <TextField disabled label={t('features.Clients.components.BasicInfoSectionShow.province')} name={`employeeFamilySupportAddressInformation.province`+`${i18n.language === 'th'? "NameThai" : "NameEng"}`} />
          </BoxTriple>
          {/* <TextField disabled label={t('features.Employees.components.BasicInfoSection.address')} name={`address${i18n.language === 'th' ? 'Thai' : 'Eng'}`} type="text" /> */}

          <BoxDouble>
            <PostalCodeFieldThai handleOnChange={handlePostalQueryChange} label={t('features.Clients.components.BasicInfoSectionShow.postalcd')} name={"employeeFamilySupportAddressInformation.postalCode"} onFocus={removePostalCode}/>
            {/* <TelFieldTh label={"Phone number"} prefix={'tel'}/> */}
          </BoxDouble>
          {postalData.length === 0 && postalCodeServerError === '' ? "" : 
              <PostalDropDownMenu 
                menuItems={postalCodeServerError === '' ? postalData : postalCodeServerError} 
                onClick={(values) => selectPostal(values)} 
                language={i18n.language}
              />
          }
    </div>
  );
};

SeparatedDomesticAddr = connect(state => ({
  prefectures: getSelectOptions(state, 'prefectures')
}))(SeparatedDomesticAddr);

const SeparatedOverseaAddr = () => (
  <div>
    <TextField label="Address" name="overseaAddress" />
    <TextField label="国外居住親族への送金額" name="overseaSendingMoneyAmount" validate={isNumber} />
  </div>
);

class FamilySupport extends React.Component {
  constructor(props) {
    super(props);

    this.state = { 
      postalData: [],
      postalCodeServerError: ''
    };

    this._postalQueryChange = this._handlePostalQueryChange.bind(this);
    this.searchPostal = debounce(this.searchPostal, 500);
    this.searchPostal = this.searchPostal.bind(this);
    this.selectPostal = this.selectPostal.bind(this);
    this.removePostalCode = this.removePostalCode.bind(this);
  }

  getAddressKana(payload) {
    const { prefectureKana, cityKana, streetKana } = payload;
    return `${prefectureKana}${cityKana}${streetKana}`;
  }

  _handlePostalQueryChange(event, inputText) {
    if(inputText.length !== 5) {
      this.setState({
        postalData: [],
        postalCodeServerError : ''
      })
    }
    return handlePostalCodeChange(event)(inputText, this.searchPostal);
  }

  async searchPostal(inputText) {
    try {
      const response = await axios.get(SEARCH_POSTAL_CODE_URL, { params: { code: inputText } });
      const payload = response.data.payload.postalInfo;
      ['prefectureId', 'city', 'street'].forEach(field =>
        this.changeFieldValue(`${this.props.formKey}.${field}`, payload[field])
      );
    } catch (exception) {
      this.props.dispatch(formTouch(EMPLOYEE_FORM, `${this.props.formKey}.postalCode`));
    }
  }

  changeFieldValue(fieldName, fieldValue) {
    this.props.dispatch(formChange(EMPLOYEE_FORM, fieldName, fieldValue));
  }

  async searchPostal(inputText) {
    try {
      const response = await axios.get(SEARCH_POSTAL_CODE_URL, { params: { code: inputText } });
      const payload = response.data.payload.postalInfo;
      this.setState({
        postalData : payload
      })
    } catch (exception) {
      const errors = exception.response.data.errors;
      this.setState({ postalCodeServerError: errors.messages[0] });
      this.props.dispatch(formTouch(EMPLOYEE_FORM, `${this.props.formKey}.postalCode`));
    }
  }

  removePostalCode(){
    const { dispatch,i18n } = this.props;
    dispatch(formChange(EMPLOYEE_FORM, `${this.props.formKey}.postalCode`, null))
    dispatch(formChange(EMPLOYEE_FORM, `${this.props.formKey}.employeeFamilySupportAddressInformation.districtNameThai` ,null));
    dispatch(formChange(EMPLOYEE_FORM, `${this.props.formKey}.employeeFamilySupportAddressInformation.subdistrictNameThai` ,null));
    dispatch(formChange(EMPLOYEE_FORM, `${this.props.formKey}.employeeFamilySupportAddressInformation.provinceNameThai` ,null));
    dispatch(formChange(EMPLOYEE_FORM, `${this.props.formKey}.employeeFamilySupportAddressInformation.districtNameEng`,null));
    dispatch(formChange(EMPLOYEE_FORM, `${this.props.formKey}.employeeFamilySupportAddressInformation.subdistrictNameEng`,null));
    dispatch(formChange(EMPLOYEE_FORM, `${this.props.formKey}.employeeFamilySupportAddressInformation.provinceNameEng`,null));
  }

  async selectPostal(result) {
    var idFields = 
    [
      'districtId',
      'postalCode',
      'provinceId',
      'subdistrictId',
      'thaiPostalCodeId'
    ]
    var nameFields = [
      'districtNameEng',
      'districtNameThai',
      'provinceNameEng',
      'provinceNameThai',
      'subdistrictNameEng',
      'subdistrictNameThai'
    ]
    idFields.forEach(field => {
      this.props.dispatch(formChange(EMPLOYEE_FORM, `${this.props.formKey}.${field}`, result[field]));
    });
    nameFields.forEach(field => {
      this.props.dispatch(formChange(EMPLOYEE_FORM, `${this.props.formKey}.employeeFamilySupportAddressInformation.${field}`, result[field]));
    })
    // this.getAddress(result)
  }

  render() {
    const { formKey, index, selectedResidentType, selectedRelationship, remove } = this.props;
    return (
      <div>
        <Section title={this.props.t('features.Employees.components.FamilySupportsSection.Dependant_information')+`${index + 1}`} icon={<DeleteSquare onClick={remove} />}>
          <FormSection name={formKey}>
            <GeneralInfo {...{ selectedRelationship }} formKey={formKey}>
              {selectedResidentType &&
                selectedResidentType === 'separated_domestic' && (
                  <SeparatedDomesticAddr handlePostalQueryChange={this._postalQueryChange} postalData={this.state.postalData} postalCodeServerError={this.state.postalCodeServerError} removePostalCode={this.removePostalCode} selectPostal={this.selectPostal} formKey={formKey}/>
                )}
              {selectedResidentType && selectedResidentType === 'separated_oversea' && <SeparatedOverseaAddr />}
            </GeneralInfo>
          </FormSection>
        </Section>
      </div>
    );
  }
}

const FamilySupportItem = withTranslation('translation')(connect()(FamilySupport));

const hasFamilySupport = value => value && value === '1';

const defaultFamilySupportItem = {
  disabledPersonType: 'no',
  isTaxDependency: true,
  residentType: 'together',
  yearlyIncome: 0,
  yearlyEarning: '0'
};

let FamilySupports = ({ fields, selectedFamilySupport, fetchValueByIndex, handleRemoveItem }) => {
  const { t } = useTranslation();
  return (
    <div>
      {hasFamilySupport(selectedFamilySupport) &&
        fields.map((familySupportItem, index) => (
          <FamilySupportItem
            key={familySupportItem}
            formKey={familySupportItem}
            index={index}
            selectedRelationship={fetchValueByIndex('relationshipType')(index)}
            selectedResidentType={fetchValueByIndex('residentType')(index)}
            remove={() => handleRemoveItem(fields)(index)}
          />
        ))}
      {hasFamilySupport(selectedFamilySupport) && (
        <div className="u-ta-r u-mt20 u-mb20">
          <div role="button" tabIndex="0" onClick={() => fields.push(defaultFamilySupportItem)} className="u-txt-addinfo">
            <PlusSquare size={20} className="u-txt-addinfo-icon" />{t('features.Employees.components.FamilySupportsSection.Add_dependant')}
          </div>
        </div>
      )}
    </div>
  );
};

FamilySupports = connect(
  state => ({
    selectedFamilySupport: selector(getEmployeeFormValues(state), 'familySupport'),
    fetchValueByIndex: fetchValueByIndexAndField(selector(getEmployeeFormValues(state), 'employeeFamilySupports'))
  }),
  dispatch => ({
    handleRemoveItem: fields => index => {
      fields.remove(index);
      if (fields.length === 1) dispatch(formChange(EMPLOYEE_FORM, 'familySupport', '0'));
    }
  })
)(FamilySupports);

const FamilySupportsSection = ({ familySupports, addDefaultSupportIfBlank }) => {
  const { t } = useTranslation();
  return (
    <div>
      <RadioField label={t('features.Employees.components.FamilySupportsSection.Dependant_application')} name="familySupport" options={familySupports} onChange={addDefaultSupportIfBlank} />
      <FieldArray name="employeeFamilySupports" component={FamilySupports} />
      <FormSection name="employee">
        <CheckboxField name="isSubmissionDeduction" label={t('features.Employees.components.FamilySupportsSection.Application_of_dependant_deduction_form_for_the_following_salary')} />
      </FormSection>
    </div>
  );
};

export default connect(
  () => ({
    familySupports: [{ label: i18next.t('features.Employees.components.FamilySupportsSection.Yes'), value: '1' }, { label: i18next.t('features.Employees.components.FamilySupportsSection.No'), value: '0' }]
  }),
  (dispatch, ownProps) => ({
    addDefaultSupportIfBlank: e => {
      const inputedSupports = _.get(ownProps, 'inputedSupports');
      const hasSupport = e.target.value === '1';
      if (!hasSupport || !_.isEmpty(inputedSupports)) {
        return;
      }
      dispatch(arrayPush(EMPLOYEE_FORM, 'employeeFamilySupports', defaultFamilySupportItem));
    }
  })
)(FamilySupportsSection);

export const customEmployeeFamilySupportValidate = values => {
  const { employeeFamilySupports } = values;
  const errors = { employeeFamilySupports: [] };

  if (!employeeFamilySupports) {
    return undefined;
  }

  employeeFamilySupports.forEach((familySupport, index) => {
    const maxDependentMoney = determineMaxDependentMoney(familySupport.relationshipType === 'spouse');
    if (+familySupport.yearlyEarning > maxDependentMoney && familySupport.isTaxDependency) {
      set(
        errors.employeeFamilySupports,
        `[${index}].yearlyEarning`,
        `が${maxDependentMoney /
          10000}万円を超えて扶養に入れる事はできません。税の扶養対象のチェックを外すか、年間所得に${maxDependentMoney}以下の値を入力してください。`
      );
    }
  });

  return errors.employeeFamilySupports.length > 0 ? errors : undefined;
};
